// [NO-FINALIZAR] modal do no "Finalizar atendimento"
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  root: { display: "flex", flexWrap: "wrap" },
}));

const FlowBuilderAddCloseTicketModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (open === "edit") {
      setMessage((data && data.data && data.data.message) || "");
      setActiveModal(true);
    } else if (open === "create") {
      setMessage("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    const msg = (message || "").trim();
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data && data.data), message: msg } });
    } else if (open === "create") {
      onSave({ message: msg });
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="sm" scroll="paper">
        <DialogTitle>
          {open === "create" ? "Adicionar finalização de atendimento" : "Editar finalização de atendimento"}
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" style={{ marginBottom: 12 }}>
            Quando o fluxo chegar aqui, o ticket é finalizado sem enviar a pesquisa NPS.
            A mensagem abaixo é opcional e é enviada antes de fechar.
          </Typography>
          <TextField
            label="Mensagem de despedida (opcional)"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            {i18n.t("contactModal.buttons.cancel")}
          </Button>
          <Button color="primary" variant="contained" onClick={handleSave}>
            {open === "create" ? "Adicionar" : "Editar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddCloseTicketModal;
